import Stylus from './Stylus';

// Select and manipulate objects.
class StylusPointer extends Stylus {
  stylusType = 'pointer';

  iconClass() {
    return 'fa-regular fa-arrow-pointer';
  }

  description() {
    return 'pointer';
  }
}

export default StylusPointer;
